<article>
  @defer (when review() && assets()) {
    <section class="page-1">
      <app-insights-as-page1 [building]="review().building" [start]="review().review.dates.start" [end]="review().review.dates.end" />
    </section>

    @for (t of telemetry(); track $index) {
      <div class="asset asset-{{ t.assetid }} mb-1">
        <div class="asset-title"><app-asset-icon [assetTypeId]="t.asset.assetType_id"></app-asset-icon> {{ t.asset.title }}</div>
        @if (t.telemetry?.length) {
          <app-d3-chart [asset]="t.asset" [hasToClickToInteract]="true" [canAnnotate]="true" [canZoom]="false" height="200" [telemetry]="t.telemetry" [showLegend]="true" [minMaxFromData]="true" [penWidth]="0.8" />
          <div class="annotation-edit">
            <div class="rag rag-{{ t.annotation.rag }} mr-1"></div>
            <div>
              <div class="annotation-asset-{{ t.asset.id }}">
                {{ t.annotation.text }}
              </div>
            </div>
          </div>
        } @else {
          @if (t.telemetry) {
            <app-info-panel>No Data</app-info-panel>
          } @else {
            <i class="mdi mdi-spin-x2 mdi-loading"></i>..
          }
        }
      </div>
    }

    @if (review().battery) {
      <div class="asset asset-battery mb-1">
        <div class="asset-title"><app-asset-icon [assetTypeId]="67"></app-asset-icon> Batteries</div>

        <div class="annotation-edit">
          <div class="rag rag-{{ review().battery.rag }} mr-1"></div>
          <div>
            <div class="annotation-asset-battery">
              {{ review().battery.text }}
            </div>
          </div>
        </div>
      </div>
    }
  }
</article>
